import notificationDOM from './notification';
import './toast.less';
var notification;

var notice = function notice(type, content) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2000;
  var onClose = arguments.length > 3 ? arguments[3] : undefined;
  if (!notification) notification = notificationDOM;
  return notification.addNotice({
    type: type,
    content: content,
    duration: duration,
    onClose: onClose
  });
};

export default {
  /* info(content, duration, onClose) {
    return notice('info', content, duration, onClose);
  }, */
  success: function success(content, duration, onClose) {
    return notice('success', content, duration, onClose);
  },
  warning: function warning(content, duration, onClose) {
    return notice('warning', content, duration, onClose);
  },
  error: function error(content, duration, onClose) {
    return notice('error', content, duration, onClose);
  },
  loading: function loading(content, duration, onClose) {
    return notice('loading', content, duration, onClose);
  }
};